export function isUserAgent(agentName: string) {
  return window.navigator.userAgent.includes(agentName)
}
